export enum DirectEngagementFormDeadEndModalTypes {
  LEGAL_SUPPORT_HOURS = 'LEGAL_SUPPORT_HOURS',
  MIN_PAY_STATES = 'MIN_PAY_STATES',
  PAY_AS_YOU_GO_BUDGET = 'PAY_AS_YOU_GO_BUDGET',
  RESERVED_PRICING = 'RESERVED_PRICING',
}
